<template>
    <div class="app-content content px-1 py-2">
        <div class="content-wrapper">
            <backToDashboard></backToDashboard>
            <div class="content-header row">
                <div class="content-header-left col-md-4 col-12 mb-2">
                    <h2 class="content-header-title mt-4 mb-0 d-inline-block">Statistiques</h2>
                    <fieldset class="mt-2 form-group position-relative">
                        <select class="form-control" id="DefaultSelect" v-on:change="goToStatistics">
                            <option>Mes statistiques</option>
                            <option selected="">Statistiques agent</option>
                        </select>
                    </fieldset>
                </div>
            </div>
            <div class="content-body">
                <!-- Basic example section start -->
                <section id="basic-examples">
                    <div class="row">
                        <div class="col-md-3">
                            <div id="users-list" class="list-group position-relative">
                                <div class="media-list">
                                    <div id="accordionWrap3" role="tablist" aria-multiselectable="true">
                                        <div class="card">
                                            <div v-for="(skill, index) in Agents" :key="index + 'skill'">
                                                <div class="card-header border-bottom">
                                                    <b-link v-b-toggle="skill.label" variant="primary" href="#" class="card-title text-dark w-100 d-block" v-on:click="setCurrentSkill(skill)">
                                                        {{skill.label}}
                                                    </b-link>
                                                </div>
                                                <b-collapse @show="getStatsBySkill" :id="skill.label" class="card-collapse" accordion="agents">
                                                    <a href="JavaScript:void(0);" v-bind:class="{'media border-bottom w-100 d-block' : innerIndex == skill.data.length - 1 , 'media border-0 w-100 d-block' : innerIndex != skill.data.length - 1}" v-for="(agent, innerIndex) in skill.data" :key="innerIndex + 'agent'" v-on:click="getSupervisorStats(agent.uuid)">
                                                        <div class="media-body w-100">
                                                            <span class="list-group-item-heading" v-if="agent.first_name || agent.last_name">{{agent.first_name}} {{agent.last_name}}</span>
                                                            <span class="list-group-item-heading" v-else>{{agent.email}}</span>
                                                        </div>
                                                    </a>
                                                </b-collapse>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-xl-2 col-lg-6 col-12">
                                    <div class="card pull-up">
                                        <div class="card-content">
                                            <div class="card-body">
                                                <div class="media d-flex">
                                                    <div class="media-body text-left">
                                                        <h3 class="info">{{SupervisorStats.waiting_count}}</h3>
                                                        <h6>Discussions</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-2 col-lg-6 col-12">
                                    <div class="card pull-up">
                                        <div class="card-content">
                                            <div class="card-body">
                                                <div class="media d-flex">
                                                    <div class="media-body text-left">
                                                        <h3 class="info">{{SupervisorStats.average_waiting | formatMinutes}}</h3>
                                                        <h6>Temps d'attente moyen</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-2 col-lg-6 col-12">
                                    <div class="card pull-up">
                                        <div class="card-content">
                                            <div class="card-body">
                                                <div class="media d-flex">
                                                    <div class="media-body text-left">
                                                        <h3 class="info">{{SupervisorStats.average_running | formatMinutes}}</h3>
                                                        <h6>Temps de traitement moyen</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-2 col-lg-6 col-12">
                                    <div class="card pull-up">
                                        <div class="card-content">
                                            <div class="card-body">
                                                <div class="media d-flex">
                                                    <div class="media-body text-left">
                                                        <h3 class="info">{{SupervisorStats.agent_count}}</h3>
                                                        <h6>Agents en ligne</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-2 col-lg-6 col-12">
                                    <div class="card pull-up">
                                        <div class="card-content">
                                            <div class="card-body">
                                                <div class="media d-flex">
                                                    <div class="media-body text-left">
                                                        <h3 class="info">{{SupervisorStats.handle_rate}}%</h3>
                                                        <h6>Discussions traitées / Discussions arrivées</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-2 col-lg-6 col-12">
                                    <div class="card pull-up">
                                        <div class="card-content">
                                            <div class="card-body">
                                                <div class="media d-flex">
                                                    <div class="media-body text-left">
                                                        <h3 class="info">{{SupervisorStats.closed_count_per_agent}}</h3>
                                                        <h6>Discussions traités</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div :class="{'card p-3 loading-state': PendingRequest.get_supervisor_stats || PendingRequest.get_supervisor_csv_stats, 'card p-3': !PendingRequest.get_supervisor_stats}">
                                <loader v-if="PendingRequest.get_supervisor_stats || PendingRequest.get_supervisor_csv_stats"></loader>
                                <div class="card-content">
                                    <div class="card-body p-5 text-center">
                                        <div class="row">
                                            <div class="col-md-8 mb-1">
                                                <fieldset class="form-group position-relative">
                                                    <select class="form-control" id="DefaultSelect" v-model="time" v-on:change="changeTime">
                                                        <option :selected="true" value="lastweek">Les 7 derniers jours</option>
                                                        <option value="today">Aujourd'hui</option>
                                                        <option value="yesterday">Hier</option>
                                                        <option value="thismonth">Ce mois-ci</option>
                                                    </select>
                                                </fieldset>
                                            </div>
                                            <div class="col-md-4 mb-1 text-right">
                                                <button class="btn btn-info  round" v-on:click="getSupervisorCsvStats">Télécharger</button>
                                            </div>
                                        </div>
                                        <div>
                                            <chart :stats="SupervisorStats" :time="time"></chart>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
// import formatData from '../module/stats'
import backToDashboard from '../components/layout/backToDashboard.vue'
import Loader from '../views/Loader'
import Chart from '../components/charts/chart.vue'

export default {
  components: {
    'backToDashboard': backToDashboard,
    'loader': Loader,
    'chart': Chart
  },
  data: function () {
    return {
      time: 'lastweek',
      currentSkill: '',
      details: {},
      chartOptions: [
        ['Running', 0],
        ['Waiting', 0],
        ['Late', 0],
        ['Closed', 0]
      ],
      loaded: false,
      currentAgent: ''
    }
  },
  computed: {
    AgentStats () {
      return this.$store.getters.getStats
    },
    SupervisorStats () {
      return this.$store.getters.getSupervisorStats
    },
    AllSkills () {
      return this.$store.getters.getSkills
    },
    Agents () {
      return this.$store.getters.getAgentsBySkill
    },
    SupervisorStatsCsv () {
      return this.$store.getters.getSupervisorCsvStats
    },
    PendingRequest () {
      return this.$store.getters.getPendingRequests
    }
  },
  methods: {
    changeTime () {
      let params = {
        interval: this.time,
        agent: this.currentAgent,
        skill: this.currentSkill.uuid
      }

      this.$socket.getSupervisorStats(params)
    },
    goToStatistics () {
      this.$router.push({
        path: '/statistics'
      })
    },
    setCurrentSkill (skill) {
      this.currentSkill = skill
    },
    getStatsBySkill () {
      let params = {
        interval: this.time,
        agent: null,
        skill: this.currentSkill.uuid
      }
      this.$socket.getSupervisorStats(params)
    },
    getSupervisorStats (agent) {
      this.loaded = false
      this.currentAgent = agent

      let params = {
        interval: this.time,
        agent: agent,
        skill: this.currentSkill.uuid
      }

      this.$socket.getSupervisorStats(params)
    },
    getSupervisorCsvStats () {
      let params = {
        interval: this.time,
        agent: this.currentAgent,
        skill: this.currentSkill.uuid
      }
      this.$socket.getSupervisorCsvStats(params)
    }
  },
  watch: {
    SupervisorStatsCsv: function (newResponse, oldResponse) {
      if (newResponse.length) {
        let csvContent = 'data:text/csv;charset=utf-8,'
        csvContent = csvContent + newResponse
        let data = encodeURI(csvContent)
        let filename = this.currentAgent + '.csv'
        let link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', filename)
        link.click()
      }
    }
  },
  mounted: function () {
    this.$socket.getAgents()
  }
}
</script>
